// The espionage global, read once per snapshot for the mission tab.
import type { GameSnapshot } from '@aod/protocol';
import { useMemo } from 'react';
import { type Espionage, readEspionage } from './espionage.js';

export function useEspionageView(snapshot: GameSnapshot | null, seat: number): Espionage | null {
  return useMemo(() => readEspionage(snapshot, seat), [snapshot, seat]);
}
